/** Display label for autocomplete result */
export function formatPlace(place) {
  if (!place) return '';
  const code = place.code ? ` (${place.code})` : '';

  if (place.type === 'airport') {
    const city = place.city_name && place.city_name !== place.name ? ` · ${place.city_name}` : '';
    const country = place.country_name ? `, ${place.country_name}` : '';
    return `${place.name}${city}${country}${code}`;
  }

  const country = place.country_name ? `, ${place.country_name}` : '';
  return `${place.name}${country}${code}`;
}

/** Short subtitle under main label in dropdown */
export function formatPlaceMeta(place) {
  if (!place) return '';
  if (place.type === 'airport') {
    return [place.city_name, place.country_name].filter(Boolean).join(' · ');
  }
  return place.country_name || '';
}
